import { Lock, PlaneLanding, Clock, Map, Users } from "lucide-react";
import { Reveal, SectionTitle } from "./Reveal";
import { useT } from "../../i18n/LangContext";

export const Why = () => {
  const w = useT().why;
  const items = [
    { icon: Lock, ...w.price },
    { icon: PlaneLanding, title: w.greet.title, text: w.greet.text },
    { icon: Clock, ...w.clock },
    { icon: Map, title: w.island.title, text: w.island.text },
    { icon: Users, title: w.fleet.title, text: w.fleet.items.map((f) => f.name).join(" · ") },
  ];
  return (
    <section id="why-taxcy" className="scroll-mt-16 bg-white px-5 py-16 sm:px-8 lg:py-20" data-testid="why-taxcy-section">
      <div className="mx-auto grid max-w-7xl items-center gap-10 lg:grid-cols-2 lg:gap-16">
        <Reveal>
          <img src="/meet.webp" alt={w.greet.alt} loading="lazy" className="aspect-[4/3] w-full rounded-xl object-cover" data-testid="why-image" />
        </Reveal>
        <Reveal delay={0.08}>
          <SectionTitle>
            {w.title} {w.titleAccent}
          </SectionTitle>
          <ul className="mt-8 space-y-6">
            {items.map(({ icon: Icon, title, text }) => (
              <li key={title} className="flex gap-4" data-testid="why-item">
                <Icon className="mt-0.5 h-5 w-5 shrink-0 text-[#FFD000]" />
                <div>
                  <h3 className="text-base font-bold text-black">{title}</h3>
                  <p className="mt-1 text-sm leading-relaxed text-zinc-600 sm:text-base">{text}</p>
                </div>
              </li>
            ))}
          </ul>
        </Reveal>
      </div>
    </section>
  );
};
